var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{class:_vm.style.maxValueCell,attrs:{"data":_vm.data.MaxVolume || _vm.data.MaxVolume === 0 ? _vm.data.MaxVolume : '',"isChecked":true},on:{"update":_vm.updateFromCell,"apply":_vm.onApply}})}
var staticRenderFns = []

export { render, staticRenderFns }